// eslint-disable-next-line import/prefer-default-export
export const addressSelects = {
  data() {
    return {
      houses: [
        { type: "Casa", code: 1 },
        { type: "Departamento", code: 2 },
        { type: "Condominio", code: 3 },
      ],
      regions: [
        { name: "Arica y Parinacota", code: 1 },
        { name: "Tarapacá", code: 2 },
        { name: "Antofagasta", code: 3 },
        { name: "Atacama", code: 4 },
        { name: "Coquimbo", code: 5 },
        { name: "Valparaíso", code: 6 },
        { name: "Región Metropolitana", code: 7 },
        { name: "O'Higgins", code: 8 },
        { name: "Maule", code: 9 },
        { name: "Ñuble", code: 10 },
        { name: "Bío Bío", code: 11 },
        { name: "Araucanía", code: 12 },
        { name: "Los Ríos", code: 13 },
        { name: "Los Lagos", code: 14 },
        { name: "Aysén", code: 15 },
        { name: "Magallanes y la Antártica Chilena", code: 16 },
      ],
    };
  },
};
